<img [src]="src" [alt]="alt" class="thumbnail" (click)="zoomIn()" />

<div #imageContainer>
  <div *ngIf="zoom" class="zoom-container" (click)="zoomOut()" [ngStyle]="{ 'top.px': top, 'left.px': left }">
    <img [src]="src" [alt]="alt" [ngStyle]="{ 'margin-left.px': imgLeft, 'margin-top.px': imgTop }" />
  </div>
</div>
